import script from "./InputSearchSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSearchSecondary.vue?vue&type=script&setup=true&lang=js"

import "./InputSearchSecondary.vue?vue&type=style&index=0&id=b1a5a516&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1a5a516"]])

export default __exports__